import { render, staticRenderFns } from "./TicketStatistics.vue?vue&type=template&id=540d3f04&scoped=true&"
import script from "./TicketStatistics.vue?vue&type=script&lang=js&"
export * from "./TicketStatistics.vue?vue&type=script&lang=js&"
import style0 from "./TicketStatistics.vue?vue&type=style&index=0&id=540d3f04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540d3f04",
  null
  
)

export default component.exports